var map = {
	"./bgDecoration.png": 3300,
	"./photoDownDesktop.png": 5186,
	"./photoDownMobile.png": 3633,
	"./photoDownTablet.png": 2372,
	"./photoUpDesktop.png": 8849,
	"./photoUpMobile.png": 2486,
	"./photoUpTablet.png": 569
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9066;